export default __webpack_public_path__ + "files/1_1_Example_of_a_swot_analysis.docx";